import Button from './Button';

interface Props {
  nameClass1: string,
  nameClass2: string,
  handleClick: any,
  parameterHandle: any,
}

const CreateButton = ({
  nameClass1,
  nameClass2,
  handleClick,
  parameterHandle,
}: Props) => (
  <Button
    className={nameClass1}
    onClick={() => handleClick(parameterHandle)}
  >
    <i className={nameClass2} />
  </Button>
);

export default CreateButton;
